import template from './recap-table-row.html';
const recapTableRow = {
    bindings: {
        highlight: '=?',
        label: '@',
    },
    template,
    transclude: true,
};
export default angular
    .module('gm.wealth.common')
    .component('gmwRecapTableRow', recapTableRow).name;



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/common/components/recap-table-row/recap-table-row.ts